import { render, staticRenderFns } from "./jianyan.vue?vue&type=template&id=57efd2d6&scoped=true&"
import script from "./jianyan.vue?vue&type=script&lang=ts&"
export * from "./jianyan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57efd2d6",
  null
  
)

export default component.exports